import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import GrainOverlay from "./components/GrainOverlay";
import Home from "./pages/Home";
import Capabilities from "./pages/Capabilities";
import About from "./pages/About";
import Contact from "./pages/Contact";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-ivory">
      <BrowserRouter>
        <ScrollToTop />
        <GrainOverlay />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
